/**
 * Textos da área da conta em pt-BR (S15–S18).
 * Fora do escopo de Lucas: aqui só ficam as chaves que S17/S18 consomem.
 */
export const copy = {
  common: {
    save: 'Salvar',
    saving: 'Salvando…',
    cancel: 'Cancelar',
    close: 'Fechar',
    retry: 'Tentar novamente',
    back: 'Voltar',
    loading: 'Carregando…',
    yes: 'Sim',
    no: 'Não',
    none: 'Não informado',
  },
  nav: {
    overview: 'Visão geral',
    personalInfo: 'Dados pessoais',
    security: 'Segurança',
    label: 'Conta',
    logout: 'Sair',
  },
  overview: {
    greeting: 'Olá, {name}',
    subtitle: 'Veja um resumo da sua conta, complete seus dados e acompanhe a segurança do acesso.',
    completionTitle: 'Complete seu perfil',
    completionDesc: 'Seu perfil está {percent}% completo.',
    mandatoryDone: '{done} de {total} dados obrigatórios preenchidos',
    optionalDone: '{done} de {total} dados opcionais preenchidos',
    sessionsTitle: 'Sessões ativas',
    sessionsDesc: 'Dispositivo com acesso à sua conta agora.',
    sessionFallback: 'Este navegador',
    sessionFallbackDesc: 'Sessão atual',
    manageSessions: 'Gerenciar sessões',
    profileLink: 'Completar meus dados',
    noName: 'por aqui',
  },
  personalInfo: {
    title: 'Dados pessoais',
    subtitle: 'Veja e atualize as informações da sua conta Alelo.',
    profileTitle: 'Seu perfil',
    profileDesc: 'Dados cadastrados na sua conta.',
    motherTitle: 'Filiação',
    edit: 'Editar {field}',
    editTitle: 'Editar {field}',
    emptyValue: 'Não informado',
    loadError: 'Não conseguimos carregar seus dados agora.',
    loadErrorHint:
      'Se preferir, você continua vendo as informações da sua sessão atual.',
    saveError: 'Não foi possível salvar',
    saveErrorGeneric: 'Tente novamente em instantes.',
    saveSuccess: 'Alteração salva.',
    required: 'Este campo é obrigatório.',
    invalidDate: 'Informe uma data válida.',
    tooLong: 'Use no máximo {max} caracteres.',
    exportTitle: 'Exportar perfil',
    exportDesc: 'Baixe uma cópia dos seus dados em formato JSON.',
    exportAction: 'Baixar meus dados',
    exportFile: 'alelo-perfil.json',
    socialTitle: 'Contas vinculadas',
    socialDesc: 'Provedores de identidade ligados à sua conta.',
    socialEmpty: 'Nenhum provedor social vinculado.',
  },
  security: {
    title: 'Segurança',
    subtitle: 'Gerencie a senha, as sessões ativas e a confirmação em duas etapas.',
    passwordTitle: 'Senha',
    passwordDesc:
      'Enviamos um e-mail para você criar uma nova senha com segurança.',
    passwordAction: 'Alterar senha',
    passwordSentTitle: 'E-mail enviado',
    passwordSent: 'Enviamos um e-mail para você criar uma nova senha.',
    passwordFailed: 'Não conseguimos enviar o e-mail. Tente novamente.',
    mfaTitle: 'Confirmação em duas etapas',
    mfaOn: 'Ativa',
    mfaOff: 'Inativa',
    mfaOnDesc: 'Sua conta pede um código adicional a cada novo acesso.',
    mfaOffDesc: 'Ative para proteger a sua conta mesmo se a senha vazar.',
    sessionsTitle: 'Sessões ativas',
    sessionsDesc: 'Dispositivos com acesso à sua conta.',
    terminateAll: 'Encerrar todas',
    confirmTerminateTitle: 'Encerrar todas as sessões?',
    confirmTerminateMessage:
      'Você será desconectado de todos os dispositivos, inclusive este.',
    confirmTerminateAction: 'Encerrar todas',
    revoke: 'Revogar',
    revokeTitle: 'Revogar acesso?',
    revokeMessage:
      'Este dispositivo precisa fazer login de novo para acessar a sua conta.',
    revokeAction: 'Revogar',
    revoking: 'Revogando…',
    lastAccess: 'Último acesso {when}',
    currentSession: 'Esta sessão',
    showMore: 'Ver mais',
    showLess: 'Ver menos',
    ip: 'Endereço IP',
    createdAt: 'Início da sessão',
    id: 'Identificador',
    empty: 'Nenhuma outra sessão ativa.',
    loadError: 'Não conseguimos listar as sessões.',
    loadErrorHint:
      'Tente novamente em alguns instantes ou fale com o atendimento Alelo.',
    revokeFailed: 'Não foi possível revogar a sessão.',
    terminateFailed: 'Não foi possível encerrar as sessões.',
  },
  session: {
    invalidTitle: 'Sessão inválida',
    invalidBody: 'Não foi possível concluir a entrada. Comece de novo pela tela de login da Alelo.',
    linkUsedTitle: 'Link de acesso expirado',
    linkUsedBody:
      'Este link já foi usado ou não vale mais. Peça um novo link de acesso na tela de login.',
    goToLogin: 'Ir para o login Alelo',
    finishing: 'Finalizando entrada…',
  },
  errors: {
    auth: 'Não foi possível entrar na sua conta.',
    offline:
      'Não conseguimos falar com o serviço da conta. Verifique sua conexão.',
  },
} as const

export type Copy = typeof copy
